import { on } from '@ember/modifier';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed, set } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismDataBar,
  PrismIcon,
  PrismTooltip,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { gt } from 'ember-truth-helpers';

interface HotelMarketInsightListsListItemsListItemCountrySignature {
  Args: {
    countrySearch: unknown;
  };
}

export default class HotelMarketInsightListsListItemsListItemCountry extends Component<HotelMarketInsightListsListItemsListItemCountrySignature> {
  @service declare intl: Services['intl'];
  open = false;

  @computed(
    // eslint-disable-next-line ember/use-brace-expansion
    'args.countrySearch.airportSearches.[]',
    'args.countrySearch.maxPercentageToUseForBar',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get airportSearchesFormatted() {
    let result = [];
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.args.countrySearch?.airportSearches?.length) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      result = this.args.countrySearch?.airportSearches.map(
        // @ts-expect-error: Incorrect type
        (airportSearch) => ({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          airport: airportSearch.airport,
          // format percentage using intl percent style, we can use the search_fraction for that since ember-intl already multiplies by 100
          searchFraction: this.intl.formatNumber(
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
            airportSearch.search_fraction,
            {
              style: 'percent',
              maximumFractionDigits: 1,
              minimumFractionDigits: 1,
            },
          ),
          // We opted to use the same max-values as for the country bars to make it better to visualise
          valueProgressBarData: [
            {
              widthPercentage: Math.round(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                ((airportSearch.search_fraction * 100) /
                  // @ts-expect-error: Incorrect type
                  this.args.countrySearch?.maxPercentageToUseForBar) *
                  100,
              ),
            },
          ],
        }),
      );
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return result;
  }

  @computed('args.countrySearch.airportSearches.[]')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasAirports() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.countrySearch?.airportSearches?.length;
  }

  @action
  toggleDropdown(): void {
    set(this, 'open', !this.open);
  }

  <template>
    {{! @glint-nocheck }}
    <li
      class="breakdown-list__item breakdown-list__item--border-bottom flex flex-col"
    >
      <div
        class="breakdown-list__item__button flex flex-col items-center justify-center"
      >
        {{#if this.hasAirports}}
          <button
            class="button--unstyled breakdown-list__item__collapse-button flex items-center justify-center"
            data-test-id="country-breakdown-list-button"
            type="button"
            {{on "click" this.toggleDropdown}}
          >
            <span
              class={{if
                this.open
                "breakdown-list__item__collapse-button__icon--open"
                ""
              }}
            >
              <PrismIcon @color="inherit" @name="chevron-right" @size="small" />
            </span>
          </button>
        {{/if}}
      </div>
      <div class="breakdown-list__item__content flex flex-row">
        <div class="breakdown-list__item__progress-bar flex flex-col">
          <PrismDataBar
            @data={{@countrySearch.valueProgressBarData}}
            as |DataBar|
          >
            <DataBar.label @text={{@countrySearch.countryFormatted}} />
            <DataBar.value @text={{@countrySearch.searchPercentage}} />
          </PrismDataBar>
        </div>
        <div class="breakdown-list__item__metric flex flex-col">
          <p class="text-200--regular">
            {{if
              (gt @countrySearch.averageLos 0)
              @countrySearch.averageLosFormatted
              (t "general.missing")
            }}
          </p>
        </div>
      </div>
      {{#if this.hasAirports}}
        <div class="flex flex-row">
          <ul
            class="breakdown-list breakdown-list--nested
              {{if this.open 'open' ''}}"
          >
            {{#each this.airportSearchesFormatted as |airportSearch|}}
              <li
                class="breakdown-list__item breakdown-list__item--border-bottom flex flex-col"
              >
                <div class="breakdown-list__item__content flex flex-row">
                  <div class="breakdown-list__item__progress-bar flex flex-col">
                    <PrismDataBar
                      @data={{airportSearch.valueProgressBarData}}
                      as |DataBar|
                    >
                      <DataBar.label @text={{airportSearch.airport}} />
                      <DataBar.value @text={{airportSearch.searchFraction}} />
                    </PrismDataBar>
                    <PrismTooltip @text={{airportSearch.airport}} />
                  </div>
                </div>
              </li>
            {{/each}}
          </ul>
        </div>
      {{/if}}
    </li>
  </template>
}
